/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

export interface PlayerControlInterface {
    /**
     * **Feature:** Sets flag to clear the player's browser cache on next launch.
     */
    clearBrowserCacheOnReboot(): Promise<void>;

    /**
     * **Feature:** Reboot the player's host system.
     *
     * @todo convert to asynchronous function
     */
    rebootSystem(): void | Promise<void>;
}

export function supportsPlayerControl(platform: unknown): platform is PlayerControlInterface {
    if (platform instanceof PlayerPmc) {
        return (
            platform.supportsMessage(PlatformMessage.ClearBrowserCacheOnReboot) &&
            platform.supportsMessage(PlatformMessage.RebootSystem)
        );
    }

    return (
        platform instanceof Object &&
        'clearBrowserCacheOnReboot' in platform &&
        'rebootSystem' in platform
    );
}
